var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "none",
      strokeWidth: 7,
      display: "inline-block"
    },
    viewBox: "0 0 76 144",
    width: 18,
    height: 18,
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 4 68 68-68 68"
  })));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBzdHlsZT0iZmlsbDogbm9uZTsgc3Ryb2tlLXdpZHRoOiA3cHg7ZGlzcGxheTogaW5saW5lLWJsb2NrOyIgdmlld0JveD0iMCAwIDc2IDE0NCIgd2lkdGg9JzE4cHgnIGhlaWdodD0nMThweCcgYXJpYS1oaWRkZW49InRydWUiIGZvY3VzYWJsZT0iZmFsc2UiPgogICAgPHBhdGggZD0iTTQgNGw2OCA2OC02OCA2OCI+PC9wYXRoPgo8L3N2Zz4=";